import React from 'react';

const SidebarToggleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3.25" y="4.25" width="17.5" height="15.5" rx="2.25" stroke="currentColor" strokeWidth="1.8" />
    <path d="M9 4.25v15.5" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

export default SidebarToggleIcon;
